const Resources = {

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Cost Center',
            href:   '/building-cost-center',
            arrow:  " ",
        },
    ],

    table_headers: [
        { 
          text:     'Cost Center Name',  
          align:    'start', 
          value:    'name',
        //   type:     'link',
        },
        {   
            text:   'Cost Center #',
            value:  'cost_center'
        },
        { 
          text:     `Director's First Name`,
          value:    'director_first_name'
        },
        { 
            text:   `Director's Last Name`,
            value:  'director_last_name'
        },
        { 
            text:   `Director's Ext`,
            value:  'director_ext' 
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            type: 'text_link_action',
            sort_type: 'number'
        },
    ],

    excel_file_headers: {
        'Cost Center Name': 'name',
        'Cost Center #': 'cost_center',
        'Director\'s First Name': 'director_first_name',
        'Director\'s Last Name': 'director_last_name',
        'Director\'s Ext': 'director_ext',
        'Notes': 'notes',
    },

    excel_fields_required: {
        name:                   true,
        cost_center:            true,
        director_first_name:    true,
        director_last_name:     true,
        director_ext:           false,
        notes:                  false,
    },

    empty_format_data: [
        {
            name:                   '',
            cost_center:            '',
            director_first_name:    '',
            director_last_name:     '',
            director_ext:           '',
            notes:                  '',
        },
    ],

    helps: [
        {
            label: '¿How to add a Cost Center?', 
            instruction: `https://scribehow.com/embed/Add_a_Cost_Center__Bs7SFkVBR9C1WjMXa9M-iA?as=scrollable`
        },
        {
            label: '¿How to delete Cost Centers?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Cost_Centers__DCoNgXNMT5yi4unkoLY7Iw?as=scrollable`
        },
    ]

}

export default Resources